<section class="code-similarity-check">
  <section class="code-similarity-check-header">
    <h1>{{'new_entries.code_similarity_check' | translate}}</h1>
    <button (click)="closeDialog()">
      <img src="../../../../assets/report_v2/close_big.svg" alt="close">
    </button>
  </section>
  <section class="code-similarity-check-container">
    <span
      [innerHTML]="'new_entries.code_similarity_initiation_message' | translate: { type: (type == 'check' ? 'check' : 'recheck') }"></span>
  </section>
  <section class="code-similarity-check-buttons">
    <button (click)="returnNo()" class="secondary-button">{{ 'new_entries.cancel' | translate }}</button>
    <button (click)="returnYes()" class="button-primary">{{ 'new_entries.code_similarity_check' | translate }}</button>
  </section>
</section>